/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of StoreBanner
 * Alfapeople -Customisation object -For Stor selection page
 */

import React, { Component } from 'react';

export interface IPlayDohItems {
  itemImage?: string;
  itemText?: string;
  itemLink?: string;
}

export interface IPlayDoh extends IPlayDohItems {
  imageUrl?: string;
  headingText?: string;
  playDohLink?: string;
  itemList: IPlayDohItems[];
}

/**
 *
 * StoreBanner component
 * @extends {React.PureComponent<IOurStoresProps<IOurStoresData>>}
 */
export class PlayDoh extends Component {
  private readonly playDoh: IPlayDoh = {
    imageUrl:
      'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1UrL',
    headingText:
      'simple Play-Doh compound projects to mold, stretch and shape their imaginations!',
    playDohLink: '/play-doh',
    itemList: [
      {
        itemImage:
          'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1Xst',
        itemText: 'make a pretend apple',
        itemLink: '/playdoh-how-to-make-apple',
      },
      {
        itemImage:
          'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1ZYV',
        itemText: 'make a pretend apple',
        itemLink: '/playdoh-how-to-make-a-castle',
      },
      {
        itemImage:
          'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1UrK',
        itemText: 'make a beach ball',
        itemLink: '/playdoh-how-to-make-a-beach-ball',
      },
      {
        itemImage:
          'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1ZYU',
        itemText: 'make a bunny',
        itemLink: '/playdoh-how-to-make-a-bunny',
      },
    ],
  };

  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <div className='row'>
          <div className='col-md-12'>
            <div className='doh-iamge'>
              <a href={this.playDoh.playDohLink} role='button'>
                <img
                  className='img-responsive'
                  src={this.playDoh.imageUrl}
                  alt={this.playDoh.headingText}
                />
              </a>
            </div>
          </div>
          <div className='col-md-12'>
            <div className='doh-text'>
              <p>{this.playDoh.headingText}</p>
            </div>
          </div>
        </div>
        <div className='row p-home-product-bar'>
          {this.playDoh.itemList.map((item) => (
            <div className='col-md-3'>
              <div className='how-to-img'>
                <a href={item.itemLink} role='button'>
                  <img src={item.itemImage} alt={this.playDoh.headingText} />
                </a>
              </div>
              <div className='how-to'>
                How to :<a href={item.itemLink}>{item.itemText}</a>
              </div>
            </div>
          ))}
        </div>
      </React.Fragment>
    );
  }
}

export default PlayDoh;
